const REPEAT_TAP_MS = 1000;

let lastTap: { gameId: number; at: number } | null = null;

// A second tap on the same tile within REPEAT_TAP_MS is the same launch.
export function isRepeatTap(gameId: number) {
  const now = Date.now();
  const repeat = lastTap?.gameId === gameId && now - lastTap.at < REPEAT_TAP_MS;
  lastTap = { gameId, at: now };
  return repeat;
}
